// REP fields may carry a Unicode byte-order mark. It is metadata, not text.
export function cleanFacility(value) {
  const text = String(value || '').trim();
  if (text.includes('ÿþ') || text.includes('þÿ') || text.includes('ï»¿') || text.includes('\ufffd'))
    return '';
  return text.replace(/^\ufeff/, '').trim();
}
export function readRepText(bytes, start, length) {
  const part = bytes.subarray(start, start + length);
  let offset = 0;
  let encoding = 'windows-1252';
  let stride = 1;
  if (part[0] === 255 && part[1] === 254) {
    offset = 2;
    stride = 2;
    encoding = 'utf-16le';
  } else if (part[0] === 254 && part[1] === 255) {
    offset = 2;
    stride = 2;
    encoding = 'utf-16be';
  } else if (part[0] === 239 && part[1] === 187 && part[2] === 191) {
    offset = 3;
    encoding = 'utf-8';
  }
  let end = offset;
  while (end + stride <= part.length) {
    if (part[end] === 0 && (stride === 1 || part[end + 1] === 0)) break;
    end += stride;
  }
  if (end + stride > part.length) return ''; // Do not read beyond the known field.
  try {
    const text = new TextDecoder(encoding, { fatal: true })
      .decode(part.subarray(offset, end))
      .trim();
    if (
      Array.from(text).some(
        (c) => c.charCodeAt(0) <= 31 || (c.charCodeAt(0) >= 127 && c.charCodeAt(0) <= 159)
      )
    )
      return '';
    return text;
  } catch {
    return '';
  }
}
